'use client';
import React from 'react';

import { Breadcrumbs } from '../../../../components/breadcrumbs';
import { EditorialPageFullWidth } from '../../../../components/page-components/editorial-page-full-width/editorial-page-full-width';
import { IMeetingPlacePageEditorialFullWidth } from '../../../../lib/fragments/meetingPlacePageEditorialFullWidth';
import { IMeetingplacePageHomeMinifiedChina } from '../../../../lib/fragments/meetingPlacePageHome-minified';

interface ChinaMeetingPlacePageEditorialFullWidthProps {
  contentfulMeetingPlacePageEditorialFullWidth: IMeetingPlacePageEditorialFullWidth;
  contentfulMeetingPlacePageHome: IMeetingplacePageHomeMinifiedChina;
}

const ChinaMeetingPlacePageEditorialFullWidth = ({
  metaData,
  node_locale,
  meetingPlacePageEditorialFullWidth,
  meetingPlacePageHome,
}: any) => {
  const page = meetingPlacePageEditorialFullWidth;
  const homepage = meetingPlacePageHome;
  return (
    <>
      <main className="bg-background-primary-light lg:-ml-22 lg:bg-transparent lg:px-0">
        <Breadcrumbs
          breadcrumbs={[page?.name]}
          homeText={homepage?.breadcrumbHomeText}
          cssClass="lg:ml-22 lg:px-0 px-6 !pt-4 !lg-pt-0"
          node_locale={node_locale}
        />
        <EditorialPageFullWidth page={page} node_locale={node_locale} />
      </main>
    </>
  );
};
export default ChinaMeetingPlacePageEditorialFullWidth;

// export const query = graphql`
//   query ChinaMeetingPlacePageEditorialFullWidthQuery(
//     $id: String!
//     $language: String!
//     $tagId: String!
//     $languages: [String!]
//   ) {
//     contentfulMeetingPlacePageEditorialFullWidth(
//       id: { eq: $id }
//       node_locale: { in: $languages }
//     ) {
//       ...MeetingPlacePageEditorialFullWidth
//     }
//     contentfulMeetingPlacePageHome(
//       metadata: { tags: { elemMatch: { contentful_id: { eq: $tagId } } } }
//       node_locale: { eq: $language }
//     ) {
//       ...MeetingPlacePageHomeMinified
//     }
//   }
// `;

// export const Head = ({
//   data,
//   pageContext,
// }: PageProps<ChinaMeetingPlacePageEditorialFullWidthProps, PageContext>) => {
//   const page = data?.contentfulMeetingPlacePageEditorialFullWidth;
//   const homepage = data?.contentfulMeetingPlacePageHome;
//   const seoDescription = getSeoDescription(
//     page.seoDescription?.seoDescription,
//     // page.body?.raw,
//   );

//   return (
//     <ChinaSeo
//       title={page?.name}
//       homepage={homepage}
//       page={page}
//       description={seoDescription}
//       pageContext={pageContext}
//     />
//   );
// };
